<script module lang="ts">
	export type TxtHeadingVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

	export type TxtVariant =
		| TxtHeadingVariant
		| 'body1'
		| 'body2'
		| 'body3'
		| 'strong1'
		| 'strong2'
		| 'display1'
		| 'display2'
		| 'label1'
		| 'label2'
		| 'label3'
		| 'label4';

	export const TxtVariants = Object.freeze([
		'display1',
		'display2',
		'h1',
		'h2',
		'h3',
		'h4',
		'h5',
		'h6',
		'body1',
		'body2',
		'body3',
		'strong1',
		'strong2',
		'label1',
		'label2',
		'label3',
		'label4'
	]) as TxtVariant[];

	export const TxtVariantsMap: Record<TxtVariant, string> = Object.freeze({
		h1: 'font-silka text-gray-900 text-[2rem] leading-[2.25rem] tracking-[-0.0625rem] font-[600] sm:text-[3rem] sm:leading-[3rem]',
		h2: 'font-silka text-gray-900 text-[1.75rem] leading-[2.25rem] tracking-[-0.03125rem] font-[600] sm:text-[2.25rem] sm:leading-[2.5rem]',
		h3: 'font-silka text-gray-900 text-[1.5rem] leading-[2rem] tracking-[0] font-[600] sm:text-[1.875rem] sm:leading-[2.25rem]',
		h4: 'font-silka text-gray-900 text-[1.25rem] leading-[1.75rem] tracking-[0] font-[600] sm:text-[1.5rem] sm:leading-[2rem]',
		h5: 'font-silka text-gray-900 text-[1.125rem] leading-[1.75rem] tracking-[0] font-[600] sm:text-[1.25rem]',
		h6: 'font-silka text-gray-900 text-[1rem] leading-[1.5rem] tracking-[0] font-[600] sm:text-[1rem]',
		display1:
			'font-silka text-gray-900 text-[3rem] leading-[3rem] font-[600] sm:text-[4.5rem] sm:leading-[4.5rem]',
		display2:
			'font-silka text-gray-900 text-[2.5rem] leading-[2.5rem] font-[600] sm:text-[3.75rem] sm:leading-[3.75rem]',
		body1: 'font-silka text-gray-700 text-[1rem] leading-[1.5rem]',
		body2: 'font-silka text-gray-700 text-[0.875rem] leading-[1.25rem]',
		body3: 'font-silka text-gray-700 text-[0.75rem] leading-[1rem]',
		strong1: 'font-silka text-gray-700 text-[1rem] leading-[1.5rem] font-[500]',
		strong2: 'font-silka text-gray-700 text-[0.875rem] leading-[1.25rem] font-[500]',
		label1: 'font-silka text-gray-900 text-[1.125rem] leading-[1.5rem] font-[500] tracking-[0]',
		label2: 'font-silka text-gray-900 text-[1rem] leading-[1.25rem] font-[500] tracking-[0]',
		label3: 'font-silka text-gray-900 text-[0.875rem] leading-[1rem] font-[500] tracking-[0]',
		label4: 'font-silka text-gray-900 text-[0.75rem] leading-[1rem] font-[500] tracking-[0]'
	});
</script>

<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	let {
		variant = 'body1',
		dataCy = undefined,
		component = variant?.startsWith('h') ? (variant as TxtHeadingVariant) : 'p',
		children,
		...rest
	}: Props = $props();

	interface Props {
		id?: string;
		style?: string;
		href?: string | null;
		title?: string;
		for?: string;
		variant?: TxtVariant;
		dataCy?: string | undefined;
		'data-cy'?: string | undefined;
		component?: string;
		rel?: string;
		target?: string;
		class?: string | null | undefined;
		children?: import('svelte').Snippet;
		onclick?: () => void;
		align?: string;
	}

	let classes = $derived(twMerge(TxtVariantsMap[variant], `variant-${variant}`, rest.class));
</script>

<svelte:element this={component} {...rest} class={classes} data-cy={dataCy || rest['data-cy']}>
	{@render children?.()}
</svelte:element>
